import { useState } from 'react';
import axios from 'axios';
import { Link, useSearchParams } from 'react-router-dom';

const API = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    if (password.length < 6) { setErr('Пароль должен быть не короче 6 символов'); return; }
    if (password !== password2) { setErr('Пароли не совпадают'); return; }
    setBusy(true);
    try {
      await axios.post(`${API}/auth/password-reset/confirm`, { token, new_password: password });
      setDone(true);
    } catch (e) {
      setErr(e?.response?.data?.detail || 'Не удалось изменить пароль');
    }
    setBusy(false);
  };

  return (
    <div style={s.page}>
      <form style={s.card} onSubmit={submit}>
        <img src="/refero-logo-vert.svg" alt="Réfero" style={s.logoImg} />
        <div style={s.logoSub}>кабинет врача</div>
        <h2 style={s.title}>Новый пароль</h2>
        {!token ? (
          <div style={s.err}>Ссылка неверна — в ней нет токена. Запросите сброс пароля заново.</div>
        ) : done ? (
          <div style={s.sentText}>Пароль изменён. Теперь можно войти с новым паролем.</div>
        ) : (
          <>
            <label style={s.label}>Новый пароль</label>
            <input style={s.input} type="password" value={password} onChange={e => setPassword(e.target.value)} autoFocus />
            <label style={s.label}>Повторите пароль</label>
            <input style={s.input} type="password" value={password2} onChange={e => setPassword2(e.target.value)} />
            {err && <div style={s.err}>{err}</div>}
            <button style={s.btn} type="submit" disabled={busy}>{busy ? 'Сохранение…' : 'Сохранить пароль'}</button>
          </>
        )}
        <div style={s.links}>
          <Link to="/login" style={s.link}>← Назад ко входу</Link>
        </div>
      </form>
    </div>
  );
}

const s = {
  page: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F6F8FB', fontFamily: 'Inter, system-ui, sans-serif', padding: 20, boxSizing: 'border-box' },
  card: { background: '#fff', borderRadius: 16, padding: 36, width: '100%', maxWidth: 380, boxSizing: 'border-box', boxShadow: '0 8px 30px rgba(27,43,75,0.08)' },
  logoImg: { width: 150, height: 'auto', display: 'block', margin: '0 auto 6px' },
  logoSub: { color: '#2EC4B6', fontSize: 13, fontWeight: 600, textAlign: 'center', marginBottom: 8 },
  title: { color: '#1B2B4B', fontSize: 18, fontWeight: 600, margin: '8px 0 20px' },
  label: { display: 'block', color: '#64748b', fontSize: 13, margin: '12px 0 6px' },
  input: { width: '100%', boxSizing: 'border-box', border: '1px solid #e2e8f0', borderRadius: 10, padding: '11px 14px', fontSize: 15, outline: 'none' },
  sentText: { color: '#334155', fontSize: 14, lineHeight: 1.5, background: '#f0fdfa', border: '1px solid #99f6e4', borderRadius: 10, padding: '14px 16px' },
  err: { color: '#ef4444', fontSize: 13, marginTop: 12 },
  btn: { width: '100%', marginTop: 20, background: '#2EC4B6', color: '#fff', border: 'none', borderRadius: 10, padding: '12px', fontSize: 15, fontWeight: 600, cursor: 'pointer' },
  links: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10, marginTop: 18 },
  link: { color: '#2EC4B6', textAlign: 'center', fontSize: 13, textDecoration: 'none', fontWeight: 500 },
};
